import { format } from '@teetsh/app/src/utils/time/format';
import { isoDatePatternWithSlashes } from '@teetsh/app/src/utils/time/datePatterns';
import { CahierJournalView } from 'containers/CahierJournal/types';

export function getTodayDateUrl(view: CahierJournalView) {
  return `cahier-journal/${view}/${format(
    new Date(),
    'fr-FR',
    isoDatePatternWithSlashes,
  )}`;
}
